import { S3Client, GetObjectCommand, PutObjectCommand, DeleteObjectCommand } from '@aws-sdk/client-s3';
import { Upload } from "@aws-sdk/lib-storage";
import { CognitoIdentityClient } from '@aws-sdk/client-cognito-identity';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-provider-cognito-identity';
import cognitoAuthConfig from '../../config';

const s3 = (user) => {
    return new S3Client({
        region: cognitoAuthConfig.region,
        // requestChecksumCalculation: "WHEN_REQUIRED",
        credentials: fromCognitoIdentityPool({
            client: new CognitoIdentityClient({ region: cognitoAuthConfig.region }),
            identityPoolId: cognitoAuthConfig.identityPoolId,
            logins: {
                [`cognito-idp.${cognitoAuthConfig.region}.amazonaws.com/${cognitoAuthConfig.userPoolId}`]: user.id_token
            },
        })
    })
};

const PutObject = async (user, key, body) => {
    const blob = new Blob([body], { type: 'text/plain' });
    const upload = new Upload({
        client: s3(user),
        params: {
            Bucket: user.org,
            Key: key,
            Body: blob
        }
    })
    upload.on("httpUploadProgress", (progress) => {
        console.log(progress);
    });
    // Start the upload and wait for it to complete
    await upload.done();
    console.log("Upload successful!");
    return

    let command = new PutObjectCommand({
        Bucket: user.org,
        Key: key,
        Body: body,
        // ContentType: 'text/plain'
    });
    let result = await s3(user).send(command).then(
        (data) => {
            console.log('success', data)
            return
        },
        (error) => {
            console.log('error', error)
            return error
        }
    )
    return result
}
export { PutObject }